/**
 * Author : Shakthi Priya
 * Purpose : PageTitle component can be used for giving the tile of each page.
 * The name of the page should be given as props.
 */

import styles from './PageTitle.module.scss';
import PropTypes from 'prop-types';

function PageTitle(props) {
  const { label } = props;

  return <h3 className={styles.pageTitle}>{label}</h3>;
}

PageTitle.propTypes = {
  label: PropTypes.string,
};
export default PageTitle;
